import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";

export class CapturedPiece extends Phaser.Group {

    public static ICON_SCALE: number = .7;

    public pieceImage: Phaser.Image;

    private quantityLabel: Phaser.Text;
    private piecesCounter: number;

    constructor(game: Phaser.Game, pieceType: string) {

        super(game, null, "captured-piece");

        this.piecesCounter = 0;

        const pieceInfo: {textureName: string, color: string} = GameVars.getPieceInfo(pieceType);

        this.pieceImage = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", pieceInfo.textureName);
        this.pieceImage.scale.set(CapturedPiece.ICON_SCALE);
        this.pieceImage.anchor.set(.5);
        this.pieceImage.alpha = .5;
        this.add(this.pieceImage);

        let fill = pieceInfo.color === GameConstants.WHITE ? "#F6F9EF" : "#1b2d3d";

        this.quantityLabel = new Phaser.Text(this.game, 34, 6, "x" + this.piecesCounter, { font: "20px Roboto Slab Light", fill: fill, align: "center"});
        this.quantityLabel.visible = false;
        this.add(this.quantityLabel);
    }

    public setCapturedPieces(n: number): void {

        this.piecesCounter = n;

        this.pieceImage.alpha = n > 0 ? 1 : .5;

        this.quantityLabel.visible = n > 0 ? true : false;
        this.quantityLabel.text = "x" + this.piecesCounter;
    }

    public pieceCaptured(): void {

        this.piecesCounter ++;

        this.pieceImage.alpha = 1;

        this.quantityLabel.text = "x" + this.piecesCounter;
        this.quantityLabel.visible = true;

        this.game.add.tween(this.pieceImage.scale)
        .to({x: 1.075 * CapturedPiece.ICON_SCALE, y: 1.075 * CapturedPiece.ICON_SCALE}, 150, Phaser.Easing.Elastic.Out, true, 0, 0, true);
    }
}
